import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { FirearmCompetencyTypeClient, FirearmCompetencyTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

const getFirearmCompetencyTypeClient = () => new FirearmCompetencyTypeClient(API_BASE_URL, axiosInstance);

// TanStack Query Hooks

// Non-cached search for admin tables
export const useFirearmCompetencyTypeSearch = () => {
  const search = async (params: any) => {
    const response = await getFirearmCompetencyTypeClient().searchFirearmCompetencyTypes(params);
    return {
      results: response?.data?.results || [],
      totalCount: response?.data?.totalCount || 0,
    };
  };
  return { search };
};

// Get by ID
export const useFirearmCompetencyTypeById = (id: string) =>
  useQuery({
    queryKey: ['firearmCompetencyType', id],
    queryFn: async () => {
      const response = await getFirearmCompetencyTypeClient().getFirearmCompetencyTypeById(id);
      return response?.data;
    },
    enabled: !!id,
  });

// Create mutation
export const useCreateFirearmCompetencyType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: FirearmCompetencyTypeDTO) => {
      await getFirearmCompetencyTypeClient().createFirearmCompetencyType(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['firearmCompetencyTypes'] });
    },
  });
};

// Update mutation
export const useUpdateFirearmCompetencyType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: FirearmCompetencyTypeDTO }) => {
      await getFirearmCompetencyTypeClient().updateFirearmCompetencyType(id, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['firearmCompetencyTypes'] });
    },
  });
};

// Delete mutation
export const useDeleteFirearmCompetencyType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await getFirearmCompetencyTypeClient().deleteFirearmCompetencyType(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['firearmCompetencyTypes'] });
    },
  });
};